export default __webpack_public_path__ + "static/media/k2.f71d67e2.jpg";